/* eslint-disable no-dupe-keys */
/* eslint-disable max-len */
/**
 * 1.footer: English/Chinese environment copyright, privacy policy, and user agreement;
 * If a variable similar to 'year' is configured, the format is ES6 template string format;
 * Can be configured with any format of plain text, text with HTML tags, text with variables, and text with variables with HTML tags.
 * 2.versionDropdown: The version list displayed in the version drop-down box for each project,
 * regardless of the current version or language, displays the configured content;
 * Compatible with previous logic, if a project or a project in a certain language is not configured here,
 * it will be displayed according to the original logic of read the docs.
 * Note: If there is a connector in the repo name, such as repo: data quality, it should be written as' data quality '
 * 3. bannerContent: The content displayed by the banner is not configured to display the banner.
 */
import zhContext from '~/themeLocale/zh-CN.js';
import enContext from '~/themeLocale/en-US.js';

export const versionDropdown = {
  dtv: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0']
  },
  sso: {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0']
  },
  maf: {
    en: ['2.4.4', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.4', '2.3.0', '2.2.0', '2.1.0']
  },
  eoc: {
    en: ['2.4.0'],
    zh_CN: ['2.4.0']
  },
  'app-portal': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'alarm-management': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0']
  },
  alert: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'alert-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-quality': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0']
  },
  'metric-management': {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  'metric-api': {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  'data-asset-catalog': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-catalog-api': {
    en: ['2.4.0', '2.3.0'],
    zh_CN: ['2.4.0', '2.3.0']
  },
  control: {
    en: ['3.1.0', '2.4.4', '2.4.0'],
    zh_CN: ['3.1.0', '2.4.4', '2.4.0']
  },
  cds: {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  reporting: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0']
  },
  wmt: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0']
  },
  monitor: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0']
  },
  'reporting-api': {
    en: ['3.1.0', '3.0.0', '2.4.4'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4']
  },
  'cds-app-api': {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  'app-development': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'onboarding-tool': {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  'onboarding-tool-api': {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  'device-integration': {
    en: ['3.1.0', '2.4.4', '2.4.0', '2.3.0'],
    zh_CN: ['3.1.0', '2.4.4', '2.4.0', '2.3.0']
  },
  enos: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  dcm: {
    en: ['2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.3.0', '2.2.0', '2.1.0']
  },
  'device-connection': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'device-provisioning': {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  'notification-mgmt': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0']
  },
  api: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'model-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'asset-tree-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'asset-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'connection-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'iam-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'dps-api': {
    en: ['2.4.4', '2.4.0'],
    zh_CN: ['2.4.4', '2.4.0']
  },
  'configuration-center': {
    en: ['2.4.4'],
    zh_CN: ['2.4.4']
  },
  apim: {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-standards': {
    en: ['2.4.4'],
    zh_CN: ['2.4.4']
  },
  'data-asset-mgmt': {
    en: ['2.4.4'],
    zh_CN: ['2.4.4']
  },
  'data-sharing': {
    en: ['2.4.4'],
    zh_CN: ['2.4.4']
  },
  'schedule-center': {
    en: ['2.4.4'],
    zh_CN: ['2.4.4']
  },
  'data-policy': {
    en: ['2.4.4'],
    zh_CN: ['2.4.4']
  },
  'data-source-reg-app': {
    en: ['3.0.0', '2.4.4'],
    zh_CN: ['3.0.0', '2.4.4']
  },
  'data-source-reg': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-archiving': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-subscription': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'time-series-data': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'enos-edge': {
    en: ['2.4.6', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.6', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'edge-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'wmt-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0']
  },
  'app-register-api': {
    en: ['3.1.0', '3.0.0', '2.4.4'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4']
  },
  'app-portal-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'batch-processing-api': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'batch-processing': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-federation': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-federation-api': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'tsdb-data-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'tsdb-policy-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'stream-processing-api': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'stream-processing': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'ai-analytics': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  'data-asset-auth': {
    en: ['2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.3.0', '2.2.0', '2.1.0']
  },
  'data-sync': {
    en: ['2.4.0', '2.3.0', '2.2.0', '2.1.0'],
    zh_CN: ['2.4.0', '2.3.0', '2.2.0', '2.1.0']
  },
  dmaas: {
    en: ['2.4.4'],
    zh_CN: ['2.4.4']
  },
  'modelling-tool': {
    en: ['3.0.0'],
    zh_CN: ['3.0.0']
  },
  'data-subscription-api': {
    en: ['3.1.0', '3.0.0'],
    zh_CN: ['3.1.0', '3.0.0']
  },
  'data-download-api': {
    en: ['3.1.0', '3.0.0'],
    zh_CN: ['3.1.0', '3.0.0']
  },
  bpm: {
    en: ['2.3.0', '2.2.0'],
    zh_CN: ['2.3.0', '2.2.0']
  },
  'bpm-api': {
    en: ['2.3.0', '2.2.0'],
    zh_CN: ['2.3.0', '2.2.0']
  },
  'notification-mgmt-api': {
    en: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0'],
    zh_CN: ['3.1.0', '3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0']
  }
};

const {
  currentVersion = ''
} = window.sphinxEnosThemeHeader || {};

export const getFooter = () => {
  const enLocalePrivacy = enContext[currentVersion]?.PRIVACY_POLICY || enContext.THEME.PRIVACY_POLICY;
  const zhLocalePrivacy = zhContext[currentVersion]?.PRIVACY_POLICY || zhContext.THEME.PRIVACY_POLICY;
  const enLocaleUserAgreement = enContext[currentVersion]?.USER_AGREEMENT || enContext.THEME.USER_AGREEMENT;
  const zhLocaleUserAgreement = zhContext[currentVersion]?.USER_AGREEMENT || zhContext.THEME.USER_AGREEMENT;
  return {
    en: `© ${new Date().getFullYear()} Univers. All Rights Reserved.   |   <a href='https://developer.enos-iot.com/privacy-policy/' style="color: #8A8B99;">${enLocalePrivacy}</a>   <a href='https://developer.enos-iot.com/user-agreement/' style="color: #8A8B99;">${enLocaleUserAgreement}</a>`,
    zh_CN: `© ${new Date().getFullYear()} 远景智能版权所有。   |   <a href='https://developer.enos-iot.com/zh_CN/privacy-policy/' style="color: #8A8B99;">${zhLocalePrivacy}</a>   <a href='https://developer.enos-iot.com/zh_CN/user-agreement/' style="color: #8A8B99;">${zhLocaleUserAgreement}</a>`
  };
};

export const getBannerContent = () => {
  const enLocaleBanner = enContext[currentVersion]?.BANNER_TEXT || enContext.THEME.BANNER_TEXT;
  const zhLocaleBanner = zhContext[currentVersion]?.BANNER_TEXT || zhContext.THEME.BANNER_TEXT;
  return {
    en: enLocaleBanner,
    zh_CN: zhLocaleBanner
  };
};
